export class MergedExceptionHandlerMock {
  public handleError() {
  }
  public getHandlerInstance() {
  }
  public getAllHandlerInstanceOf() {
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/exception-handlers/merged-exception-handler/merged-exception-handler.mock.ts